import { render, staticRenderFns } from "./confirmServe.vue?vue&type=template&id=23b907ee&scoped=true&"
import script from "./confirmServe.vue?vue&type=script&lang=js&"
export * from "./confirmServe.vue?vue&type=script&lang=js&"
import style0 from "./confirmServe.vue?vue&type=style&index=0&id=23b907ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b907ee",
  null
  
)

export default component.exports